export default __webpack_public_path__ + "static/media/976.a300cd27.png";